import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";
import moment from 'moment';

import { useropen, companylogourlset } from '../../redux/userInfo';
import { open, close, loadingflas } from '../../redux/popupSlice';
import { Link, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';
import Brepingtable1 from '../../component/Brepingtable1';
import Mainbanners from '../../component/Mainbanners';
import MainbannersTable from '../../component/MainbannersTable';


import * as APIS from "../../utils/service";
import { getMemberinfo, numFormat, useIntersectionObserver, polygon_point_check, hpHypen, filterItemsMain } from "../../utils/utils";
import consts from '../../libs/consts';
import userEvent from '@testing-library/user-event';

// 팝업 컴포넌트
import MainPopup from './MainPopup';

// 신규 컴포넌트
import NewCheckBox from '../../component/NewCheckBox';
import Select from '../../component/Select';

// 신규 모듈
import { useMediaQuery } from 'react-responsive'
import ApexChart from "react-apexcharts";

import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import { setWeek } from 'date-fns';
import PopCustomLeftDetail from '../../component/PopCustomLeftDetail';
import PopProductLeftDetail from '../../component/PopProductLeftDetail';
import Contractwrite from '../../component/Contractwrite';
import CutomerDetailPop from '../../component/CutomerDetailPop';
import Radios from '../../component/Radios';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);



export default function Main({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [memberinfos, setmemberinfos] = useState('');

    const [items, setitems] = useState([]);
    const [customers, setcustomers] = useState([]);
    const [blacks, setblacks] = useState([]);
    const [componyblacks, setcomponyblacks] = useState([]);
    const [mycomponymembers, setmycomponymembers] = useState(0);
    const [allmembers, setallmembers] = useState(0);
    const [stayitemcklists, setstayitemcklists] = useState([]);
    const [staycustomercklists, setstaycustomercklists] = useState([]);
    const [meetingcustomercklists, setmeetingcustomercklists] = useState([]);

    const [company_news_list, setcompany_news_list] = useState([]);
    const [contract_list, setcontract_list] = useState([]);
    const [meetings, setmeetings] = useState([]);

    const [item_chk, setitem_chk] = useState(1); // 매물쪽 선택옵션
    const [customer_chk, setcustomer_chk] = useState(1); // 고객쪽 선택옵션
    const [itembeforemonths, setitembeforemonths] = useState([]); // 
    const [customerbeforemonths, setcustomerbeforemonths] = useState([]); // 
    const [contractbeforemonths, setcontractbeforemonths] = useState([]); // 
    const [fincustomers, setfincustomers] = useState([]); // 
    const [statlists, setstatlists] = useState([]); // 
    const [contractIdx, setcontractIdx] = useState(null);
    const [detailwrite, setdetailwrite] = useState(false);
    const [customerIdx, setcustomerIdx] = useState(0);
    const [customerdetailflag, setcustomerdetailflag] = useState(false);

    // const [newProductChk, setnewProductChk] = useState(false); // 신규접수매물
    // const [tradingProductChk, settradingProductChk] = useState(false); // 거래가능매물
    // const [directorChk, setdirectorChk] = useState(false); // 임장비율
    // const [customerChk, setcustomerChk] = useState(false); // 신규접수고객
    // const [tradingCustomerChk, settradingCustomerChk] = useState(false); // 거래가능 고객
    // const [meetingChk, setmeetingChk] = useState(false); // 미팅비율

    const [select, setselect] = useState('전체');
    const [week, setweek] = useState(moment().subtract('1', 'week').day(0).format());

    const [popupShow, setpopupShow] = useState(false);
    const [popupTitle, setpopupTitle] = useState('');
    const [popupType, setpopupType] = useState(1);

    const [listType, setlistType] = useState(1);
    const [noticedesc, setnoticedesc] = useState('');
    const [staylistconcat, setstaylistconcat] = useState('');
    const [productdetailPop, setproductdetailPop] = useState(false);
    const [customerdetailPop, setcustomerdetailPop] = useState(false);
    const [detaildata, setdetaildata] = useState({});
    const [eventlist, seteventlist] = useState([]);
    const [eventgrouplist, seteventgrouplist] = useState('');
    const [customeralls, setcustomeralls] = useState([]);
    const [crewlists, setcrewlists] = useState([]);

    const [realdatas, setrealdatas] = useState([]);
    const [posdatas, setposdatas] = useState([]);
    const [companyCount, setcompanyCount] = useState(0);
    const [areaCount, setareaCount] = useState(0);
    const [outsideCount, setoutsideCount] = useState(0);

    const [seldamdang, setseldamdang] = useState(0);
    const [damdanglist, setdamdanglist] = useState([]);


    const { configdata } = useSelector(s => s.configReducer);
    //console.log('>>> ',configdata?.consts?.category_1_OptionConsts); // 주거 상업 건물
    //console.log('>>> ',configdata?.consts?.category_2_OptionConsts); // 아파트 ~ 주거전용건물

    // let startweek = moment().startOf('week').format('YYYY-MM-DD')+" 00:00:00";
    // let endweek = moment().endOf('week').format('YYYY-MM-DD')+" 23:59:59";
    // const yoil = ['일', '월', '화', '수', '목', '금', '토'];

    const is1220 = useMediaQuery({ query: "(max-width : 1220px)" });
    const buttonStyle = {
        width: '100%',
        fontSize: is1220 ? 16 : 20,
        fontWeight: 700
    }
    let statusArrs = [];
    configdata?.consts?.itemStatusConsts?.map((x, i) => {
        if (x?.idx * 1 === 98) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'green', 'no', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 1) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 2) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 3) {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else {
            statusArrs.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx });
        }
    });
    const statusName = statusArrs;


    let statusArrs2 = [];
    configdata?.consts?.customerStatusConsts?.map((x, i) => {
        if (x?.idx * 1 === 99) {
            statusArrs2.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'no', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 1) {
            statusArrs2.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'black', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 2) {
            statusArrs2.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'blue', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else if (x?.idx * 1 === 3) {
            statusArrs2.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'red', 'y', x?.idx], labels: x?.title, values: x?.idx });
        } else {
            statusArrs2.push({ idx: x?.idx, title: x?.title, arrays: [x?.title, 'gray', 'y', x?.idx], labels: x?.title, values: x?.idx });
        }
    });
    const statusName2 = statusArrs2;

    const [stayradios, setstayradios] = useState(0);



    useEffect(() => {
        getMemberinfo(setmemberinfos);

        let sender = {}
        APIS.postData('/v1/master/users', sender).then(({ data }) => {
            if (data) {
                let damdanglistArr = [];
                data?.map((x, i) => {
                    damdanglistArr.push({ labels: `${x?.name} ${x?.rank}`, values: x?.idx });
                })
                setdamdanglist(damdanglistArr);
            }
        }).catch(({ response }) => {
        }).finally(() => {
        });

    }, []);

    useEffect(() => {
        console.log(memberinfos);
        if (memberinfos?.compony?.logo_path) {
            dispatch(
                companylogourlset({
                    companylogourl: consts.s3url + "/" + memberinfos?.compony?.logo_path
                })
            );
        }
        //memberinfos?.compony?.logo_path ? "url('"+ consts.s3url +"/"+ memberinfos?.compony?.logo_path +"')" : "url('./images/icons/user-3-fill.svg')

    }, [memberinfos]);

    useEffect(() => {
        if(memberinfos){
            getlists();
        }
    }, [week, memberinfos]);

    const getlists = () => {
        dispatch(loadingflas({ loading: true }));
        let sender = {
            weekstart: moment(week).format('YYYY-MM-DD'),
            weekend: moment(week).add(6, 'days').format('YYYY-MM-DD')
        }
        //console.log("sendersendersender", sender);
        APIS.postData('/v1/compony/dashboard', sender).then(({ data }) => {
            if (data) {
                const {
                    items, customers, blacks, componyblacks, mycomponymembers, allmembers, stayitemcklists, staycustomercklists,
                    company_news_lists, contract_lists, meetings, customeralls, crewlists, itembeforemonths, customerbeforemonths,
                    contractbeforemonths, fincustomers, realdatas, posdatas, statlists, companyUserCount, areaUserCount,
                    outsideCount, senditems
                } = data;

                console.log(meetings);

                setitems(items);
                setcustomers(customers);
                setblacks(blacks);
                setcomponyblacks(componyblacks);
                setmycomponymembers(mycomponymembers);
                setallmembers(allmembers);
                setmeetings(meetings);
                setcustomeralls(customeralls);
                setcrewlists(crewlists);
                setitembeforemonths(itembeforemonths);
                setcustomerbeforemonths(customerbeforemonths);
                setcontractbeforemonths(contractbeforemonths);
                setfincustomers(fincustomers);
                setrealdatas(realdatas);
                setposdatas(posdatas);
                setstatlists(statlists);
                setcompanyCount(companyUserCount);
                setareaCount(areaUserCount);
                setoutsideCount(outsideCount);
                
                //console.log("fincustomersfincustomersfincustomers", statlists);
                let finitems = items;
                finitems = finitems?.filter(item => {
                    return filterItemsMain(item, realdatas, posdatas);
                });
                let stayitem = [];
                //console.log(finitems);
                finitems?.map((x, i) => {
                    x.listType = 3;
                    x.durations = 0;
                    stayitem.push(x);
                })
                //console.log('>>>>>>> ', stayitemcklists);

                stayitemcklists?.map((x, i) => {
                    //console.log(x);
                    let cker = finitems?.find(item => item?.idx * 1 === x?.idx * 1);
                    if (!cker) {
                        let durations = moment.duration(moment().diff(x?.update_dt)).asDays();
                        //if (parseInt(durations) > 30 && stayitem?.find(item => item?.idx * 1 === x?.idx)?.idx === '') { //30
                        //if(parseInt(durations) > 7){ //7일로 임시 변경
                        x.order_dt = moment(x?.update_dt).format('YYYYMMDD') * 1;
                        x.listType = 0;
                        x.durations = durations;
                        stayitem.push(x);
                        //}
                    }
                });
                //console.log('>>>>>>> ', stayitem);

                let staycustomer = [];
                staycustomercklists?.map((x, i) => {
                    let durations = moment.duration(moment().diff(x?.update_dt)).asDays();
                    //console.log("parseInt(durations)", parseInt(durations));
                    //if (parseInt(durations) > 14) { //14
                    //if(parseInt(durations) > 7){ //7일로 임시 변경
                    x.order_dt = moment(x?.update_dt).format('YYYYMMDD') * 1;
                    x.listType = 1;
                    x.durations = durations;
                    staycustomer.push(x);
                    //}
                });
                console.log(staycustomercklists);


                staycustomercklists?.map((x, i) => {
                    let meetdata = meetings?.filter(item => item?.c_idx * 1 === x?.idx * 1);
                    if(meetdata < 1){
                        return;
                    }
                    let durations = moment.duration(moment().diff(meetdata[0]?.create_dt)).asDays();
                    if (parseInt(durations) < 14) { //14
                        x.order_dt = moment(x?.update_dt).format('YYYYMMDD') * 1;
                        x.listType = 1;
                        x.durations = durations;
                        //meetingcustomer.push(x);
                    }
                });

                let meetingcustomer = [];
                senditems?.filter(item => item?.u_idx*1 === memberinfos?.idx*1)?.map((x, i) => {
                    let durations = moment.duration(moment().diff(senditems?.kakaosaveDate)).asDays();
                    if (parseInt(durations) < 15) { //14
                        x.order_dt = moment(x?.update_dt).format('YYYYMMDD') * 1;
                        x.listType = 1;
                        x.durations = durations;
                        x.customer = staycustomercklists?.find(item => item?.idx*1 === x?.c_idx*1);
                        meetingcustomer.push(x);
                    }
                });
                // console.log("meetingcustomer", senditems);
                // console.log("meetingcustomer", meetingcustomer);


                setstayitemcklists(stayitem);
                setstaycustomercklists(staycustomer);
                setmeetingcustomercklists(meetingcustomer);
                setcompany_news_list(company_news_lists);
                let staylistcontact = stayitem.concat(staycustomer);
                //console.log(staycustomer);
                let orderstaylistcontact = staylistcontact.sort(function (a, b) {
                    if (a.hasOwnProperty('order_dt')) {
                        return a.order_dt - b.order_dt;
                    }
                });
                setstaylistconcat(orderstaylistcontact);

                let contractsetlist = [];
                contract_lists?.map((x, i) => {
                    //console.log(x);
                    let inputArrData = JSON?.parse(x?.contract);
                    let contractDate = inputArrData?.find(item => item?.keys === '날인일년')?.values + "-" + inputArrData?.find(item => item?.keys === '날인일월')?.values + "-" + inputArrData?.find(item => item?.keys === '날인일')?.values;
                    let addtwoyearsDate = moment(contractDate).add(2, 'y').format('YYYY-MM-DD');
                    let durations = moment.duration(moment().diff(addtwoyearsDate)).asDays();
                    // contractsetlist.push({ 
                    //     durations: parseInt(durations),
                    //     dates: moment(contractDate).add(2, 'y').format('M.DD'), 
                    //     stickers: inputArrData?.find(item => item?.keys === '건물용도')?.values, 
                    //     subjects: inputArrData?.find(item => item?.keys === '소재지')?.values
                    // });
                    x.durations = durations;
                    x.dates = moment(contractDate).add(2, 'y').format('M.DD');
                    x.stickers = inputArrData?.find(item => item?.keys === '건물용도')?.values;
                    x.subjects = inputArrData?.find(item => item?.keys === '소재지')?.values;
                    contractsetlist.push(x);
                })
                setcontract_list(contractsetlist);
                getschedultlist();
            }
        }).catch(({ response }) => {
            console.log(response);
            //const { data } = response;
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const popupOpen = (title, type) => {
        setpopupShow(!popupShow);
        setpopupTitle(title);
        setpopupType(type);
    }

    const checkNaN = (value) => {
        if (isNaN(value))
            return 0
        else
            return value
    }

    const lineChart = () => {
        let data1 = 0;
        let data2 = 0;
        let data3 = 0;
        let cusdata1 = 0;
        let cusdata2 = 0;
        let cusdata3 = 0;
        let companydata1 = 0;
        let companydata2 = 0;
        let companydata3 = 0;
        let companycusdata1 = 0;
        let companycusdata2 = 0;
        let companycusdata3 = 0;
        let companyTotal = 0;
        let areaTotal = 0;
        statlists?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1)?.map((x, i) => {
            data1 = checkNaN((data1 * 1) + (x?.newitemTotal)); //신규등록
            data2 = checkNaN((data2 * 1) + (x?.itemTotal)); //그주합산전체매물
            data3 = checkNaN((data3 * 1) + (x?.itemSatusTotal)); //그주합산전체 임장
            cusdata1 = checkNaN((cusdata1 * 1) + (x?.newcustomerTotal)); //신규등록고객
            cusdata2 = checkNaN((cusdata2 * 1) + (x?.customerTotal)); //그주합산전체고객
            cusdata3 = checkNaN((cusdata3 * 1) + (x?.customerStatusTotal)); //그주합산전체 미팅
            companyTotal = checkNaN(x?.companyUserCount);
            areaTotal = checkNaN(x?.areaUserCount);
        });
        statlists?.filter(item => item?.c_idx * 1 === memberinfos?.c_idx * 1)?.map((x, i) => {
            companydata1 = checkNaN((companydata1 * 1) + (x?.newitemTotal)); //신규등록
            companydata2 = checkNaN((companydata2 * 1) + (x?.itemTotal)); //그주합산전체매물
            companydata3 = checkNaN((companydata3 * 1) + (x?.itemSatusTotal)); //그주합산전체 임장
            companycusdata1 = checkNaN((companycusdata1 * 1) + (x?.newcustomerTotal)); //신규등록고객
            companycusdata2 = checkNaN((companycusdata2 * 1) + (x?.customerTotal)); //그주합산전체고객
            companycusdata3 = checkNaN((companycusdata3 * 1) + (x?.customerStatusTotal)); //그주합산전체 미팅
        });
        return (
            <div className='main_popup_content' style={{ marginBottom: 8 }}>
                <div className='main_popup_list_container'>
                    <div style={{ width: 736 }}>
                        <div className='main_popup_check_box'>
                            <div className='main_popup_check_flex'>

                                <NewCheckBox
                                    title={'신규 접수 매물'}
                                    value={item_chk === 1}
                                    setValue={() => {
                                        setitem_chk(1);
                                    }}
                                />
                                <NewCheckBox
                                    title={'거래가능 매물'}
                                    value={item_chk === 2}
                                    setValue={() => {
                                        setitem_chk(2);
                                    }}
                                />
                                <NewCheckBox
                                    title={'임장 비율'}
                                    value={item_chk === 3}
                                    setValue={() => {
                                        setitem_chk(3);
                                    }}
                                />
                            </div>

                            <div className='main_popup_check_flex'>
                                <NewCheckBox
                                    type={'red'}
                                    title={'신규 접수 고객'}
                                    value={customer_chk === 1}
                                    setValue={() => {
                                        setcustomer_chk(1);
                                    }}
                                />
                                <NewCheckBox
                                    type={'red'}
                                    title={'거래가능 고객'}
                                    value={customer_chk === 2}
                                    setValue={() => {
                                        setcustomer_chk(2);
                                    }}
                                />
                                <NewCheckBox
                                    type={'red'}
                                    title={'미팅 비율'}
                                    value={customer_chk === 3}
                                    setValue={() => {
                                        setcustomer_chk(3);
                                    }}
                                />
                            </div>
                        </div>

                        {/* <Line options={options} data={data} /> */}

                        <ApexChart
                            type="line"
                            //{companydata2/companyCount}={companydata2/areaCount}
                            series={[
                                {
                                    name: item_chk === 1 ? "신규 접수 매물" : item_chk === 2 ? "거래가능 매물" : "임장 비율",
                                    data: item_chk === 1 ? [data1, checkNaN(companydata1 / companyTotal).toFixed(1), checkNaN(companydata1 / areaTotal).toFixed(1)] :
                                        item_chk === 2 ? [data1, checkNaN(companydata2 / companyTotal).toFixed(1), checkNaN(companydata2 / areaTotal).toFixed(1)] :
                                            [data1, checkNaN(companydata3 / companyTotal).toFixed(1), checkNaN(companydata3 / areaTotal).toFixed(1)]
                                },
                                {
                                    name: customer_chk === 1 ? "신규 접수 고객" : customer_chk === 2 ? "거래가능 고객" : "미팅 비율",
                                    data: customer_chk === 1 ? [data1, checkNaN(companycusdata1 / companyTotal).toFixed(1), checkNaN(companycusdata1 / areaTotal).toFixed(1)] :
                                        customer_chk === 2 ? [data1, checkNaN(companycusdata2 / companyTotal).toFixed(1), checkNaN(companycusdata2 / areaTotal).toFixed(1)] :
                                            [data1, checkNaN(companycusdata3 / companyTotal).toFixed(1), checkNaN(companycusdata3 / areaTotal).toFixed(1)]
                                },
                            ]}
                            options={{
                                // theme: { mode: "dark" },
                                chart: {
                                    height: 180,
                                    type: 'line',
                                    zoom: {
                                        enabled: false
                                    },
                                    toolbar: {
                                        show: false
                                    }
                                },
                                dataLabels: {
                                    enabled: true,
                                    offsetX: 0,
                                    offsetY: -5,
                                    style: {
                                        fontSize: '12px',
                                        fontWeight: 400,
                                        colors: ['#000']
                                    },
                                    background: {
                                        enabled: false
                                    }
                                },
                                stroke: {
                                    curve: 'straight'
                                },
                                title: {
                                    show: false,
                                },
                                grid: {
                                    borderColor: '#ccc',
                                    xaxis: {
                                        lines: {
                                            show: true
                                        }
                                    },
                                    yaxis: {
                                        lines: {
                                            show: false
                                        }
                                    },
                                },
                                legend: {
                                    show: false,
                                },
                                markers: {
                                    size: 5,
                                    strokeColors: ['#5C96ED', '#D81717'],
                                },
                                xaxis: {
                                    categories: [`${memberinfos?.name} ${memberinfos?.rank}(나)`, `우리 사무소\n(1인당 평균)`, `${memberinfos?.compony?.sigungu}\n(1인당 평균)`],
                                    title: {
                                        text: '분류',
                                        offsetX: 340,
                                        offsetY: -50,
                                        style: {
                                            fontSize: '16px',
                                            fontWeight: 400,
                                        }
                                    },
                                    axisTicks: {
                                        show: false
                                    },
                                    // axisBorder: {
                                    //     show: true,
                                    //     color: '#ccc',
                                    //     offsetX: 0,
                                    //     offsetY: 0
                                    // },
                                },
                                yaxis: {
                                    title: {
                                        text: '건수',
                                        rotate: -360,
                                        offsetX: 25,
                                        offsetY: -190,
                                        style: {
                                            fontSize: '16px',
                                            fontWeight: 400,
                                        }
                                    },
                                    labels: {
                                        show: false,
                                    },
                                },
                                colors: ['#5C96ED', '#D81717'],
                            }}
                        />

                        <div className='popup_chart_box'>
                            <div className='weeks_bottom_box'>
                                <img src="./images/icons/chevron-left03.svg" width='24'
                                    onClick={() => {
                                        setweek(moment(week).subtract('1', 'week').day(1).format())
                                    }}
                                />

                                <div className='weeks_title_box'>
                                    <p>{moment(week).day(1).format('YYYY.MM.DD')} ~ {moment(week).day(0).add(7, 'days').format('YYYY.MM.DD')}</p>
                                </div>

                                <img src="./images/icons/chevron-right03.svg" width='24'
                                    onClick={() => {
                                        let weeklast = moment(week).add('1', 'week').day(6);
                                        let sumdate = moment.duration(moment().diff(weeklast)).asDays();
                                        console.log(weeklast, sumdate);
                                        // return;
                                        if (sumdate * 1 < 0) {
                                            dispatch(
                                                open({
                                                    component: '주간 업무 통계는 매주 일요일 자정을 기준으로\n1주일간 업무 통계를 집계합니다.',
                                                    title: '업무 통계 집계중',
                                                    button: "확인",
                                                    titleviewer: true,
                                                    alert: false,
                                                    onPress: () => {
                                                        dispatch(close());
                                                    },
                                                })
                                            );
                                        } else {
                                            setweek(moment(week).add('1', 'week').day(1).format())
                                        }
                                    }}
                                />
                            </div>

                            <div className='button_div'>
                                <Button
                                    buttonTxt={'전체값 확인'}
                                    className={`searchbutton active`}
                                    styles={{
                                        height: 40,
                                        minHeight: 40,
                                        fontSize: 14
                                    }}
                                    onPress={() => {
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }

    const kakaosenders = (senders = {}, sendertype = 0) => {
        senders.sendertype = sendertype;
        dispatch(
            open({
                component: '알림톡을 발송하시겠습니까?',
                title: '알림톡발송',
                button: "확인",
                buttonCencle: "닫기",
                titleviewer: true,
                alert: false,
                onPress: () => {
                    dispatch(loadingflas({ loading: true }));
                    let sender = senders;
                    APIS.postData('/v1/contract/kakaosenders', sender).then(({ data }) => {
                        if (data) {
                            dispatch(
                                open({
                                    component: `발송되었습니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        getlists();
                                        dispatch(close());
                                    }
                                })
                            );
                        }
                    }).catch(({ response }) => {
                        const { data } = response;
                        dispatch(
                            open({
                                component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                title: '알림',
                                button: "확인",
                                titleviewer: true,
                                alert: false,
                                onPress: () => {
                                    dispatch(close());
                                },
                            })
                        );
                    }).finally(() => {
                        dispatch(loadingflas({ loading: false }));
                    });
                },
                onCancelPress: () => {
                    dispatch(close());
                }
            })
        );
    }
    const listContent = () => {
        //customeralls
        let allCounts = customeralls?.length;
        let outCounts = customers?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1)?.length;
        //console.log("allCountsallCounts", allCounts, outCounts, (outCounts/allCounts)*100 );
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                {/* <div style={{ paddingBottom: 20 }}>
                    <Select 
                        divwidth={{
                            width: 200
                        }}
                        setValues={setselect}
                        values={select}
                        selectData={[
                            {labels: '전체', values: '전체'},
                            {labels: '고객번호', values: '고객번호'},
                            {labels: '고객명', values: '고객명'},
                            {labels: '최근미팅일', values: '최근미팅일'},
                            {labels: '미팅횟수', values: '미팅횟수'},
                            {labels: '담당자', values: '담당자'},
                            {labels: '자동관리 발송 횟수', values: '자동관리 발송 횟수'},
                        ]}
                    />
                </div> */}

                <div className='main_popup_list_container'>
                    {memberinfos?.level * 1 === 3 &&
                        <div style={{ width: 150, marginBottom: 10 }}>
                            <Select
                                setValues={setseldamdang}
                                values={seldamdang}
                                selectData={([{ labels: '임직원 전체', values: '' }].concat(damdanglist))}

                            />
                        </div>
                    }
                    <div style={{ width: 736 }}>
                        <div className='main_popup_list_index'>
                            <p>고객번호</p>
                            <p>고객명</p>
                            <p>최근미팅일</p>
                            <p>미팅횟수</p>
                            <p>담당자</p>
                            <p style={{ borderRight: 0 }}>자동관리 발송 횟수</p>
                        </div>

                        <div className='main_popup_list_data_box'>
                            {customers?.filter(item => {
                                if (seldamdang * 1 !== 0) {
                                    return item?.auto_status * 1 === 1 && item?.u_idx * 1 === seldamdang * 1;
                                } else {
                                    //return item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1;
                                    if (memberinfos?.level * 1 === 1 || memberinfos?.level * 1 === 2) {
                                        return item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1;
                                    } else {
                                        return item?.auto_status * 1 === 1;
                                    }
                                }
                                //return item;

                            })?.map((x, i) => {
                                let meettinglist = meetings?.filter(item => item?.c_idx * 1 === x?.idx * 1);
                                return (
                                    <div
                                        key={i} className='main_popup_list_data'
                                        style={{ cursor: 'pointer' }}
                                        onClick={() => {
                                            setcustomerIdx(x?.idx);
                                            setcustomerdetailflag(true);
                                        }}
                                    >
                                        <p>{x?.idx}</p>
                                        <p className='textcut_online'>{x?.title}</p>
                                        <p>{meettinglist?.length > 0 ? moment(meettinglist[0]?.create_dt).format('YYYY.MM.DD') : '미팅전'}</p>
                                        <p>{meettinglist?.length}번</p>
                                        <p>{x?.user?.name}</p>
                                        <p>{x?.kakaoSendCount}</p>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>

                {/* <div className='main_popup_list_bottom'>
                    <p className='main'>고객 이탈률{((outCounts / allCounts) * 100).toFixed(1)}%</p>
                    <p className='sub'>등록 된 접수·미팅고객 수 대비 이탈고객 비율</p>
                </div> */}
            </div>
        )
    }

    const alarmContent = () => {
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                <div className='main_popup_list_container'>
                    <div style={{ width: 836 }}>
                        <div className='main_popup_list_index02'>
                            <p style={{ width: 80 }}>계약번호</p>
                            <p style={{ width: 165 }}>소재지</p>
                            <p style={{ width: 64 }}>임차인명</p>
                            <p style={{ width: 56 }}>유형</p>
                            <p style={{ width: 140 }}>가격</p>
                            <p style={{ width: 64 }}>D-DAY</p>
                            <p style={{ width: 140 }}>알림톡 발송(임대)</p>
                            <p style={{ width: 140 }}>알림톡 발송(임차)</p>
                            <p style={{ width: 80, borderRight: 0 }}>삭제</p>
                        </div>

                        <div className='alarm_content_list'>
                            {contract_list?.map((x, i) => {
                                if (x?.maindelete * 1 === 1) {
                                    return;
                                }
                                //console.log(x);
                                let inputArrData = JSON.parse(x?.contract);
                                //console.log(inputArrData?.find(item => item?.keys === '매도인'));


                                let price1 = inputArrData?.find(item => item?.keys === '매매대금')?.values * 1;
                                let price2 = inputArrData?.find(item => item?.keys === '보증금')?.values * 1;

                                let names = inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.values[4]?.values;
                                let phone = inputArrData?.find(item => item?.keys === '매도인')?.values[0]?.values[3]?.values;
                                let phone2 = inputArrData?.find(item => item?.keys === '매수인')?.values[0]?.values[3]?.values;
                                let sell_type = x?.sell_type;//매물종류
                                let category = x?.category;//하위
                                let ddays = Math.floor(x?.durations);//만기디데이
                                let senders = {
                                    phone: phone?.replaceAll('-', ''), //매도
                                    phone2: phone2?.replaceAll('-', ''), //매수
                                    sell_type: sell_type,
                                    category: category,
                                    sub_category: x?.sub_category,
                                    ddays: ddays,
                                }
                                console.log(senders);
                                //상호랑 대표번호는 정보는 user로 감지 user?.compony?.title, user?.compony?.company_phone
                                //TY_2456 임대인대상
                                //TY_2457 임차인대상
                                return (
                                    <div
                                        key={i} className='contract_alarm_list'
                                        style={{ cursor: 'pointer' }}

                                    >
                                        <p style={{ width: 80, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>{x?.idx}</p>
                                        <p style={{ width: 165, textAlign: 'left', lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>{`${x?.subjects}`}</p>
                                        <p style={{ width: 64, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>{`${names}`}</p>
                                        <p style={{ width: 56, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>{x?.sell_type}</p>
                                        {x?.sell_type === '매매' &&
                                            <div style={{ width: 140, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>
                                                <p>매매가 {numFormat(price1)}만원</p>
                                            </div>
                                        }
                                        {(x?.sell_type === '전세' || x?.sell_type === '월세') &&
                                            <div style={{ width: 140, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>
                                                <p>보증금 {numFormat(price2)}만원</p>
                                            </div>
                                        }

                                        <p style={{ width: 64, lineHeight: 60 }} onClick={() => { setcontractIdx(x?.idx); setdetailwrite(true); }}>{x?.durations * 1 < 0 ? `만기` : `D-${Math.floor(x?.durations)}`}</p>
                                        <div style={{ width: 140 }} >
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#E1E2FC' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    kakaosenders(senders, 0);
                                                }}
                                            >
                                                <img src="./images/icons/notification.svg" width='20' />
                                            </div>
                                        </div>
                                        <div style={{ width: 140 }}>
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#E1E2FC' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    kakaosenders(senders, 1);
                                                }}
                                            >
                                                <img src="./images/icons/notification.svg" width='20' />
                                            </div>
                                        </div>
                                        <div style={{ width: 80 }}>
                                            <div
                                                className='popup_list_btn' style={{ backgroundColor: '#eee' }}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    dispatch(
                                                        open({
                                                            component: '삭제하시겠습니까?',
                                                            title: '삭제하기',
                                                            button: "삭제",
                                                            buttonCencle: "닫기",
                                                            titleviewer: true,
                                                            alert: false,
                                                            onPress: () => {
                                                                dispatch(loadingflas({ loading: true }));
                                                                let sender = {
                                                                    idx: x?.idx,
                                                                    dtypes: 'main'
                                                                }
                                                                APIS.postData('/v1/contract/remove', sender).then(({ data }) => {
                                                                    if (data) {
                                                                        dispatch(
                                                                            open({
                                                                                component: `삭제되었습니다.`,
                                                                                title: '알림',
                                                                                titleviewer: true,
                                                                                alert: false,
                                                                                button: "확인",
                                                                                onPress: () => {
                                                                                    getlists();
                                                                                    dispatch(close());
                                                                                }
                                                                            })
                                                                        );
                                                                    }
                                                                }).catch(({ response }) => {
                                                                    const { data } = response;
                                                                    dispatch(
                                                                        open({
                                                                            component: '해당 기능을 실행할 수 없습니다. 관리자에게 문의하세요.',
                                                                            title: '알림',
                                                                            button: "확인",
                                                                            titleviewer: true,
                                                                            alert: false,
                                                                            onPress: () => {
                                                                                dispatch(close());
                                                                            },
                                                                        })
                                                                    );
                                                                }).finally(() => {
                                                                    dispatch(loadingflas({ loading: false }));
                                                                });
                                                            },
                                                            onCancelPress: () => {
                                                                dispatch(close());
                                                            }
                                                        })
                                                    );
                                                }}
                                            >
                                                <img src="./images/icons/trash.svg" width='20' />
                                            </div>
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>


                </div>
            </div>
        )
    }

    const executivesContent = () => {
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                <div className='work_select_box'>
                    <p className={listType === 1 && 'active'} style={{ borderTopLeftRadius: 8, borderBottomLeftRadius: 8 }}
                        onClick={() => {
                            setlistType(1);
                        }}
                    >접수기준</p>
                    <p className={listType === 2 && 'active'} style={{ borderTopRightRadius: 8, borderBottomRightRadius: 8 }}
                        onClick={() => {
                            dispatch(
                                open({
                                    component: `준비중입니다.`,
                                    title: '알림',
                                    titleviewer: true,
                                    alert: false,
                                    button: "확인",
                                    onPress: () => {
                                        dispatch(close());
                                    }
                                })
                            );
                            //setlistType(2);
                        }}
                    >수수료 기준</p>
                </div>

                <div className='main_popup_list_container'>
                    <div style={{ width: 736 }}>
                        <div className='main_popup_list_index03'>
                            <div style={{ width: 100 }}>
                                <p style={{ lineHeight: '80px' }}>담당자명</p>
                            </div>
                            <div style={{ width: 256 }}>
                                <p style={{ lineHeight: '40px' }}>매물</p>
                                <div>
                                    <p style={{ lineHeight: '40px' }}>접수</p>
                                    <p style={{ lineHeight: '40px', borderRight: 0 }}>임장</p>
                                </div>
                            </div>
                            <div style={{ width: 256 }}>
                                <p style={{ lineHeight: '40px' }}>고객</p>
                                <div>
                                    <p style={{ lineHeight: '40px' }}>접수</p>
                                    <p style={{ lineHeight: '40px', borderRight: 0 }}>미팅</p>
                                </div>
                            </div>
                            <div style={{ width: 120, borderRight: 0 }}>
                                <p style={{ lineHeight: '80px' }}>계약(잔금일기준)</p>
                            </div>
                        </div>

                        <div className='work_item_list_container'>
                            {crewlists?.map((x, i) => {
                                console.log(x);
                                console.log(itembeforemonths);
                                // console.log(
                                //     itembeforemonths,
                                //     customerbeforemonths,
                                //     contract_list,
                                //     contractbeforemonths                          
                                // )

                                return (
                                    <div key={i} className='work_item_list'>
                                        <p style={{ width: 100 }}>{x?.name}</p>
                                        <p style={{ width: 129 }}>{itembeforemonths?.filter(item => item?.status * 1 === 1 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{itembeforemonths?.filter(item => item?.status * 1 === 2 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{customerbeforemonths?.filter(item => item?.status * 1 === 1 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{customerbeforemonths?.filter(item => item?.status * 1 === 2 && item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                        <p style={{ width: 129 }}>{contract_list?.filter(item => item?.u_idx * 1 === x?.idx * 1)?.length}</p>
                                    </div>
                                )
                            })}
                        </div>

                    </div>
                </div>
            </div>
        )
    }
    const noticeViewer = () => {
        return (
            <div className='main_popup_content' style={{ marginBottom: 26 }}>
                <div className='main_popup_list_container' style={{ whiteSpace: 'pre-wrap' }}>
                    {noticedesc}
                </div>
            </div>
        );
    }
    let colorlists = JSON.parse('{"1":{"background":"#a4bdfc","foreground":"#1d1d1d"},"2":{"background":"#7ae7bf","foreground":"#1d1d1d"},"3":{"background":"#dbadff","foreground":"#1d1d1d"},"4":{"background":"#ff887c","foreground":"#1d1d1d"},"5":{"background":"#fbd75b","foreground":"#1d1d1d"},"6":{"background":"#ffb878","foreground":"#1d1d1d"},"7":{"background":"#46d6db","foreground":"#1d1d1d"},"8":{"background":"#e1e1e1","foreground":"#1d1d1d"},"9":{"background":"#5484ed","foreground":"#1d1d1d"},"10":{"background":"#51b749","foreground":"#1d1d1d"},"11":{"background":"#dc2127","foreground":"#1d1d1d"},"default":{"background":"#9a9cff","foreground":"#000000"}}');
    //console.log(colorlists['10']);


    const getschedultlist = () => {
        let thisyear = moment().format('YYYY');
        let thismonth = moment().format('MM');
        let sender = {
            year: thisyear,
            month: thismonth
        }

        //console.log("?????????????????????", colorlists);
        APIS.postData('/v1/schedule/events', sender).then(({ data }) => {
            if (data) {
                //console.log("????????????", data);
                //setlists(data);
                let listpush = [];

                // {
                //     start: moment().format('YYYY-MM-DD HH:mm:ss'),
                //     end: moment().format('YYYY-MM-DD HH:mm:ss'),
                //     title: <div ><span className='colorF00 fontsize10'>111</span>22222</div>,
                //     id: '3'
                // }
                console.log(data);
                data?.map((x, i) => {
                    let descriptions = x?.description?.replace(/<[^>]*>?/g, '');
                    //console.log(x);
                    if(!x?.end?.dateTime) {
                        return;
                    }

                    let startDates = moment(x?.start?.dateTime).format('YYYY-MM-DD');
                    let endDates = moment(x?.end?.dateTime).format('YYYY-MM-DD');
                    const startDate = startDates; // YYYY-MM-DD만 추출
                    const endDate = endDates; // YYYY-MM-DD만 추출
                    const now = moment().format('YYYY-MM-DD'); // 현재 날짜
                    // 1. 연속 일정 필터링 (시작 <= 오늘 <= 종료)
                    const isMultiDayEvent = startDate <= now && now <= endDate;
                    // 2. 오늘 시작해서 오늘 끝나는 일정도 포함 (시간 일정)
                    const isSingleDayEvent = startDate === now;
                    //console.log(isMultiDayEvent, isSingleDayEvent, startDate, now, endDate);
                    if(isMultiDayEvent || isSingleDayEvent){
                        listpush.push({
                            start: moment(x?.start?.dateTime).format('YYYY-MM-DD HH:mm:ss'),
                            end: moment(x?.end?.dateTime).format('YYYY-MM-DD HH:mm:ss'),
                            startdates: moment(x?.start?.dateTime).format('YYYY-MM-DD'),
                            enddates: moment(x?.end?.dateTime).format('YYYY-MM-DD'),
                            startmonth: moment(x?.start?.dateTime).format('YYYYMM') * 1,
                            endmonth: moment(x?.end?.dateTime).format('YYYYMM') * 1,
                            title: descriptions,
                            scheculestate: x?.summary,
                            id: x?.id,
                            backgrounds: colorlists[x?.colorId]?.background || colorlists['default']?.background,
                            foregrounds: colorlists[x?.colorId]?.foreground || colorlists['default']?.foreground,
                            orderbydates: moment(x?.start?.dateTime).format('YYYYMMDDHHmmss') * 1,
                            colorId: x?.colorId,
                        });
                    }
                    
                })

                //thistodayMonth
                //thistodayYear
                listpush = listpush.sort(function (a, b) {
                    if (a.hasOwnProperty('orderbydates')) {
                        return a.orderbydates - b.orderbydates;
                    }
                });
                //console.log(listpush);
                let ckgroupdate = thisyear + thismonth;
                let groupfilters = listpush?.filter(item => (item?.startmonth * 1 === ckgroupdate * 1 || item?.endmonth * 1 === ckgroupdate * 1))

                let groupresult = groupfilters.reduce((acc, curr) => {  // [1]
                    const { startdates } = curr;                        // [2]
                    if (acc[startdates]) acc[startdates].push(curr);  // [3]
                    else acc[startdates] = [curr];              // [4]
                    return acc;                           // [5]
                }, {});                                 // [6]

                console.log(listpush);
                seteventlist(listpush);
                seteventgrouplist(groupresult);
            }
        }).catch(({ response }) => {
            const { data } = response;
            console.log("리스트??!!", data);
            let sender = {}
            dispatch(loadingflas({ loading: true }));
            APIS.postData('/v1/schedule/colors', sender).then(({ data }) => {
                if (data) {
                    getlists();
                }
            }).catch(({ response }) => {
                const { data } = response;
            }).finally(() => {
                dispatch(loadingflas({ loading: false }));
            });
        }).finally(() => {
            dispatch(loadingflas({ loading: false }));
        });
    }

    const customerviewCker = (uidx=0) => {
        let sender = {
            uidx: uidx
        }
        APIS.postData('/v1/compony/customerviewCker', sender).then(({ data }) => {
            if (data) {
                getlists();
            }
        }).catch(({ response }) => {
        }).finally(() => {
        });
        
    }
    return (
        <Layout header={false} actives={'0'}>
            {detailwrite === true && <Contractwrite zIndexs={2005} memberinfos={memberinfos} setdetailwrite={setdetailwrite} contractIdx={contractIdx} />}

            {customerdetailflag === true && customerIdx * 1 > 0 && <CutomerDetailPop
                setcustomerdetailflag={setcustomerdetailflag}
                customerIdx={customerIdx}
                zIndexs={1001}
            />}

            {productdetailPop === true && detaildata?.idx && <PopProductLeftDetail
                row={detaildata} setproductdetailflag={setproductdetailPop}
                productIdx={detaildata?.idx} confirmdateupdate={true}
                updatemain={getlists}
            />}
            {customerdetailPop === true && detaildata && <PopCustomLeftDetail
                row={detaildata} setcustomerdetailflag={setcustomerdetailPop}
                customerIdx={detaildata?.idx} confirmdateupdate={true}
                updatemain={getlists}
            />}
            {popupShow &&
                <MainPopup
                    title={popupTitle}
                    component={
                        popupType === 1 ? lineChart() :
                            popupType === 2 ? listContent() :
                                popupType === 3 ? alarmContent() :
                                    popupType === 4 ? executivesContent() :
                                        popupType === 5 ? noticeViewer() : executivesContent()
                    }
                    setClose={() => {
                        setpopupShow(!popupShow);
                    }}
                />
            }

            <div className='main_section_div'>

                <div className='main_content_box'>

                    <div className="main_profile_area1">
                        <div
                            className="profileimg"
                            style={{
                                backgroundImage: `${memberinfos?.compony?.logo_path ? "url('" + consts.s3url + "/" + memberinfos?.compony?.logo_path + "')" : "url('./images/icons/user-3-fill.svg')"}`,
                                backgroundSize: `${memberinfos?.compony?.logo_path ? "cover" : "30px"}`,
                                border: '1px solid #999', borderRadius: '50%'
                            }}

                        />
                        <div className="profilenames">
                            {memberinfos?.compony?.title}
                        </div>
                    </div>

                    <div className='main_flex_box' style={{ marginBottom: 20 }}>

                        <div className={`main_bg_area_style01 bgareastyle1`}>
                            <div className='main_banner_new_title'>
                                <img src="./images/icons/smile_icon.svg" width='24' />
                                <p>사내 공지사항</p>
                            </div>
                            <div className='main_banner_list_box'>
                                {company_news_list?.length > 0 && company_news_list?.map((x, i) => {
                                    return (
                                        <div
                                            key={i} className='notice_list_content' style={{ cursor: 'pointer' }}
                                            onClick={() => {
                                                setnoticedesc(x?.desc);
                                                popupOpen('사내 공지사항 상세보기', 5);
                                            }}
                                        >
                                            <div className='notice_list_title'>
                                                {x?.notices * 1 === 1 &&
                                                    <p className='notice_need_type'>필독</p>
                                                }
                                                <p className='title' style={{ marginLeft: x?.notices * 1 === 1 ? 4 : 0 }}>{x?.title}</p>
                                            </div>
                                            <p>{moment(x?.create_dt).format('YYYY.MM.DD')}</p>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>

                        <div className={`main_bg_area_style02 bgareastyle1`}>
                            <div className='main_banner_new_title'>
                                <img src="./images/icons/avatar_icon.svg" width='24' />
                                <p style={{ marginRight: 20 }}>의뢰인 확인 요망</p>

                                <Radios
                                    linetype={'radioimg'}
                                    values={stayradios}
                                    setvalues={(e) => {
                                        setstayradios(e * 1);
                                    }}
                                    namevalue={[
                                        { names: '전체', values: 0 },
                                        { names: '매물', values: 1 },
                                        { names: '고객', values: 2 },
                                    ]}
                                    fontweights={400}
                                    fontSizes={14}
                                    sizes={20}
                                />
                            </div>

                            <div className='main_item_flow'>
                                <div className='main_item_list_flow'>
                                    <div className='main_item_index_list'>
                                        <p className='item_width48'>분류</p>
                                        <p className='item_width48'>상태</p>
                                        <p className='item_width100'>번호</p>
                                        <p className='item_width80'>매물종류</p>
                                        <p className='item_width240' >소재지/고객명칭</p>
                                        <p className='item_width64'>거래유형</p>
                                        <p className='item_width120'>가격</p>
                                        <p className='item_width120 '>의뢰인 연락처</p>
                                        <p className='item_width120 item_border_end'>전환예정일</p>
                                    </div>

                                    <div className='item_list_box'>
                                        {staylistconcat?.length > 0 ? staylistconcat?.filter(item => {
                                            if (stayradios === 1) {
                                                return item?.listType * 1 === 0 || item?.listType * 1 === 3;
                                            } else if (stayradios === 2) {
                                                return item?.listType * 1 === 1;
                                            } else {
                                                return item;
                                            }
                                        })?.map((x, i) => {
                                            //console.log(x);
                                            let durations = moment.duration(moment().diff(x?.update_dt)).asDays();
                                            let itemstayDate = moment(x?.update_dt).add(2, 'M').format('YYYY-MM-DD')

                                            if (x?.listType === 0 || x?.listType === 3) {
                                                if (x?.listType === 3) {
                                                    //itemstayDate = moment(x?.update_dt).add(1, 'M').format('YYYY-MM-DD')
                                                } else {
                                                    if (durations < 30) {
                                                        return;
                                                    }
                                                }
                                                return (
                                                    <div
                                                        key={i} className='main_item_td_list'
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setdetaildata(x);
                                                            setproductdetailPop(true);
                                                        }}
                                                    >
                                                        {(x?.listType === 3) ?
                                                            <p className={'item_width64 suc_type'}>{'완료 추정'}</p>
                                                            :
                                                            <p className={'item_width64 ex_type'}>{'보류 예정'}</p>
                                                        }

                                                        <p className='item_width48'>{'매물'}</p>
                                                        <p className='item_width48'>{statusName?.find(item => item?.idx * 1 === x?.status * 1)?.title}</p>
                                                        <p className='item_width100'>{x?.idx}</p>
                                                        <p className='item_width80'>
                                                            {
                                                                configdata?.consts?.category_2_OptionConsts?.filter(item => item?.idx === x?.category_2)[0]?.title
                                                            }
                                                        </p>
                                                        <p className='item_width240'>
                                                            {x?.addr}
                                                        </p>
                                                        <p className='item_width64'>{x?.sell_type}</p>
                                                        <p className='item_width120'>
                                                            {x?.sell_type === '매매' && `${numFormat(x?.price_sell)}`}
                                                            {x?.sell_type === '전세' && `${numFormat(x?.price_all)}`}
                                                            {x?.sell_type === '월세' && `${numFormat(x?.price_all)}/${numFormat(x?.price_month)}`}
                                                        </p>
                                                        <p className='item_width120'>{hpHypen(x?.client_hp)}</p>
                                                        <p className={'item_width120 after_days'}>{itemstayDate}</p>
                                                    </div>
                                                )
                                            } else {
                                                let fincheck = fincustomers?.filter(item => item?.hp === x?.hp)?.length;
                                                if (durations < 14 && fincheck === 0) {
                                                    return;
                                                }
                                                return (
                                                    <div
                                                        key={i} className='main_item_td_list'
                                                        style={{ cursor: 'pointer' }}
                                                        onClick={() => {
                                                            setdetaildata(x);
                                                            setcustomerdetailPop(true);
                                                        }}
                                                    >
                                                        {parseInt(fincheck) > 0 ?
                                                            <p className={'item_width64 suc_type'}>{'완료 추정'}</p>
                                                            :
                                                            <p className={'item_width64 ex_type'}>{'보류 예정'}</p>
                                                        }

                                                        <p className='item_width48'>{'고객'}</p>
                                                        <p className='item_width48'>{statusName2?.find(item => item?.idx * 1 === x?.status * 1)?.title}</p>
                                                        <p className='item_width100'>{x?.idx}</p>
                                                        <p className='item_width80'>
                                                            {
                                                                configdata?.consts?.category_2_OptionConsts?.filter(item => item?.idx === x?.category_2)[0]?.title
                                                            }
                                                        </p>
                                                        <p className='item_width240'>
                                                            {x?.title}
                                                            {/* {x?.order_dt} */}
                                                        </p>
                                                        <p className='item_width64'>{x?.sell_type}</p>
                                                        <p className='item_width120'>
                                                            {x?.sell_type === '매매' && `${numFormat(x['price_all_min']) + "~" + numFormat(x['price_all_max'])}`}
                                                            {x?.sell_type === '전세' && `${numFormat(x['price_all_min']) + "~" + numFormat(x['price_all_max'])}`}
                                                            {x?.sell_type === '월세' && `${numFormat(x['price_all_min']) + "~" + numFormat(x['price_all_max']) + "\n/ " + numFormat(x['price_month_min']) + "~" + numFormat(x['price_month_max'])}}`}
                                                        </p>
                                                        <p className='item_width120'>{hpHypen(x?.hp)}</p>
                                                        <p className={'item_width120 after_days'}>{itemstayDate}</p>
                                                    </div>
                                                )
                                            }
                                        })
                                            :
                                            <div className='nolistArea'>
                                                리스트가 없습니다.
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='main_flex_box'>
                        <div className={`main_bg_area_style01 bgareastyle1`}>
                            <div className='main_banner_new_title'>
                                <img src="./images/icons/calendar_icon.svg" width='24' />
                                <p>오늘의 일정</p>
                            </div>

                            {!memberinfos?.access_token ?
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: 100, textAlign: 'center' }}>
                                    구글 연동이 필요합니다.<br />
                                    일정페이지에서 구글 로그인을 해주세요.
                                </div>
                                :
                                <>
                                    <div className='main_today_list'>
                                        <img src="./images/icons/check_icon.svg" width='12.5' />
                                        <p>오늘</p>
                                    </div>
                                    <div style={{ height: 239, overflow: 'auto' }}>
                                        {eventlist?.length > 0 && eventlist?.map((x, i) => {
                                            console.log(x);
                                            let yoil = ['일', '월', '화', '수', '목', '금', '토'];

                                            return (
                                                <div key={i} 
                                                    style={{
                                                        display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                                                        padding: '8px 0px', borderBottom: '1px solid #ddd', gap: 8
                                                    }}
                                                >
                                                    <div style={{ width: 92}}>
                                                        {x?.start === x?.end ?
                                                            <>{moment(x?.start).format('HH:mm')}</>
                                                        :
                                                            <>{moment(x?.start).format('HH:mm')} ~ {moment(x?.end).format('HH:mm')}</>
                                                        } 
                                                    </div>
                                                    <div
                                                        style={{
                                                            width: "calc(100% - 100px)", display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between',
                                                            flexDirection: 'column', gap: 4
                                                        }}
                                                    >
                                                        <div className='bolds' style={{ color: colorlists[x?.colorId]?.background}}>{x?.scheculestate}</div>
                                                        <div>{x?.title}</div>
                                                    </div>
                                                </div>
                                            );
                                               
                                            // <div key={i} className='notice_list_content'>
                                            //     <div className='notice_list_title'>
                                            //         <p className='today_type01'
                                            //             style={{ backgroundColor: x?.backgrounds, color: x?.foregrounds }}
                                            //         >{x?.scheculestate}</p>
                                            //         <p className='title' style={{ marginLeft: 4 }}>{x?.title}</p>
                                            //     </div>
                                            //     <p>{moment(x?.start).format('A HH:mm')}</p>
                                            // </div>
                                        })}
                                    </div>
                                </>}
                        </div>

                        <div className={`main_bg_area_style02 bgareastyle1`}>
                            <div className='main_item_flow'>
                                <div className='main_item_list_flow'>
                                    <div className='main_banner_new_title02'>
                                        <img src="./images/icons/bubble_icon.svg" width='24' />
                                        <p>고객 매물 평가</p>
                                    </div>
                                    <div className='main_item_index_list' style={{padding:0}}>
                                        <p className='item_width64'>날짜</p>
                                        <p className='item_width100'>번호</p>
                                        <p className='item_width100'>매물종류</p>
                                        <p className='item_width48'>유형</p>
                                        <p className='item_width280' >고객명칭</p>
                                        <p className='item_width90'>미팅일</p>
                                        <p className='item_width48'>횟수</p>
                                        <p className='item_width440 item_border_end' style={{ paddingLeft: 10}}>희망가격</p>
                                    </div>

                                    {/* <div style={{ height: 240, overflow: 'auto' }}> */}
                                    <div style={{ height: 245, overflow: 'auto' }}>
                                        {meetingcustomercklists?.length > 0 ? meetingcustomercklists?.map((x, i) => {
                                            let customer = x?.customer
                                            let durations = moment.duration(moment().diff(x?.update_dt)).asDays();
                                            let meetlist = customer?.meetings;
                                            console.log(x, customer);
                                            let meetingdate = '-';
                                            if(customer?.meetings?.length > 0){
                                                meetingdate = moment(customer?.meetings[0]?.create_dt)?.format('YYYY-MM-DD');
                                            }
                                            if(!customer?.idx){
                                                return;
                                            }
                                            return (
                                                <div
                                                    key={i} className='main_meeting_td_list'
                                                    style={{ cursor: 'pointer', backgroundColor: x?.homeview? '#f7f7f7' : '' }}
                                                    onClick={() => {
                                                        setdetaildata(customer);
                                                        setcustomerdetailPop(true);
                                                        customerviewCker(x?.idx);
                                                    }}
                                                >
                                                    <p className={'item_width64 days_type'}>{durations < 1 ? '오늘' : moment(x?.update_dt).format('MM-DD')}</p>
                                                    <p className='item_width100'>{customer?.idx}</p>
                                                    <p className='item_width100'>{configdata?.consts?.category_2_OptionConsts?.filter(item => item?.idx === customer?.category_2)[0]?.title}</p>
                                                    <p className='item_width48'>{customer?.sell_type}</p>
                                                    <p className='item_width280' style={{ textAlign: 'left', paddingLeft: 10}}>{customer?.title}</p>
                                                    <p className={'item_width90 '}>{meetingdate}</p>
                                                    <p className={'item_width48 '}>{meetlist?.length}회</p>
                                                    <p className='item_width440' style={{ textAlign: 'left', paddingLeft: 10 }}>
                                                        {customer?.sell_type === '매매' && `${numFormat(customer['price_all_min']) + "~" + numFormat(customer['price_all_max'])}만원`}
                                                        {customer?.sell_type === '전세' && `${numFormat(customer['price_all_min']) + "~" + numFormat(customer['price_all_max'])}만원`}
                                                        {customer?.sell_type === '월세' && `${numFormat(customer['price_all_min']) + "~" + numFormat(customer['price_all_max']) + "/ " + numFormat(x['price_month_min']) + "~" + numFormat(x['price_month_max'])}만원`}
                                                    </p>
                                                </div>
                                            )
                                        })
                                            :
                                            <div className='nolistArea'>
                                                리스트가 없습니다.
                                            </div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='main_footer_buttons' style={{ display: 'none' }}>
                        <div className='buttons_div_box'>
                            <Button
                                buttonTxt={'점포거래소 매물 의뢰'}
                                className={`searchbutton active`}
                                styles={buttonStyle}
                                onPress={() => {
                                    dispatch(
                                        open({
                                            component: `의뢰매물 기능은 현재 준비중입니다.`,
                                            title: '알림',
                                            titleviewer: true,
                                            alert: false,
                                            button: "확인",
                                            onPress: () => {
                                                dispatch(close());
                                            }
                                        })
                                    );
                                }}
                            />
                            {/* <div className='buttons_div_box_cnt'>
                                <p>10</p>
                            </div> */}
                        </div>
                        <div className='buttons_div_box'>
                            <Button
                                buttonTxt={'미니홈 신규 문의'}
                                className={`searchbutton active`}
                                styles={buttonStyle}
                                onPress={() => {
                                    navigate('/Outsidelist')
                                    // dispatch(
                                    //     open({
                                    //         component: `의뢰매물 기능은 현재 준비중입니다.`,
                                    //         title: '알림',
                                    //         titleviewer: true,
                                    //         alert: false,
                                    //         button: "확인",
                                    //         onPress: () => {
                                    //             dispatch(close());
                                    //         }
                                    //     })
                                    // );  
                                }}
                            />
                            {outsideCount * 1 > 0 &&
                                <div className='buttons_div_box_cnt'>
                                    <p>{numFormat(outsideCount)}</p>
                                </div>}

                        </div>
                        <div className='buttons_div_box'>
                            <Button
                                buttonTxt={'이탈고객 자동 관리'}
                                className={`searchbutton active`}
                                styles={buttonStyle}
                                onPress={() => {
                                    popupOpen('이탈고객 자동 관리 현황', 2);
                                }}
                            />
                            <div className='buttons_div_box_cnt'>
                                <p>{customers?.filter(item => item?.u_idx * 1 === memberinfos?.idx * 1 && item?.auto_status * 1 === 1)?.length}</p>
                            </div>
                        </div>
                        <div className='buttons_div_box'>
                            <Button
                                buttonTxt={'임대차 계약 만기 알림'}
                                className={`searchbutton active`}
                                styles={buttonStyle}
                                onPress={() => {
                                    popupOpen('임대차 계약 만기 알림', 3);
                                }}
                            />
                        </div>
                        <div className='buttons_div_box'>
                            <Button
                                buttonTxt={'개인 업무 통계'}
                                className={`searchbutton active`}
                                styles={buttonStyle}
                                onPress={() => {
                                    popupOpen('개인 업무 통계', 1);
                                }}
                            />
                        </div>
                        {memberinfos?.level * 1 === 3 &&
                            <div className='buttons_div_box'>
                                <Button
                                    buttonTxt={'전직원 업무 통계'}
                                    className={`searchbutton active`}
                                    styles={buttonStyle}
                                    onPress={() => {
                                        popupOpen('전직원 업무 통계', 4);
                                    }}
                                />
                            </div>}
                    </div>
                </div>

            </div>
        </Layout>
    )
}
